import React, { createElement, lazy, Suspense } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Loader from 'components/Loader';

import './scss/main.scss';

const routes = [{
  path: '/time-card-calculator',
  component: lazy(() => import('pages/TimeCardCalculator')),
},{
  path: '/stripe',
  component: lazy(() => import('pages/StripeCalculator')),
},{
  path: '/generator',
  component: lazy(() => import('pages/Generator')),
},{
  path: '/invoice-calculator',
  component: lazy(() => import('pages/InvoiceCalculator')),
},{
  path: '/paypal',
  component: lazy(() => import('pages/PayPalCalculator')),
},{
  path: '*',
  component: lazy(() => import('pages/Home')),
}]

const App = () => {
  return (
    <BrowserRouter>
      <Routes>
        {routes.map(({ path, component }) => {
          return (
            <Route
              key={path}
              path={path}
              element={<Suspense fallback={<Loader />}>{createElement(component)}</Suspense>}
            />
          );
        })}
      </Routes>
    </BrowserRouter>
  );
};

export default App;
